import axios from "axios";
const REACT_APP_ADMIN_API = process.env.REACT_APP_ADMIN_API;

export const getTemplates = async (query, page = 1, cancelToken) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  const region = localStorage.getItem("region");
  try {
    const response = await axios({
      method: "get",
      url: `${REACT_APP_ADMIN_API}/api/template?db=${region}&expand_template=false&q=${query}&results_per_page=200`,
      headers: { Authorization: `Bearer ${token}` },
      cancelToken,
    });
    return {
      data: response.data.data,
    };
  } catch (e) {
    return { e };
  }
};

export const getTemplate = async (templateName) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  const region = localStorage.getItem("region");
  try {
    const response = await axios({
      method: "get",
      url: `${REACT_APP_ADMIN_API}/api/template/${templateName}?db=${region}`,
      headers: { Authorization: `Bearer ${token}` },
    });
    return {
      data: response.data,
    };
  } catch (e) {
    return { e };
  }
};

export const editTemplate = async (templateName, description, template) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  const region = localStorage.getItem("region");
  const response = await axios({
    method: "put",
    url: `${REACT_APP_ADMIN_API}/api/template/${templateName}?db=${region}`,
    headers: { Authorization: `Bearer ${token}` },
    data: {
      description,
      template,
    },
  });
  return {
    data: response.data,
  };
};

export const deleteTemplate = async (templateName) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  const region = localStorage.getItem("region");
  const response = await axios({
    method: "delete",
    url: `${REACT_APP_ADMIN_API}/api/template/${templateName}?db=${region}`,
    headers: { Authorization: `Bearer ${token}` },
  });
  return {
    data: response.data,
  };
};
